"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetFoldersDto = exports.FolderHierarchyResponseDto = exports.GetFolderHierarchyDto = exports.MoveFolderContentDto = exports.FolderInviteShowDto = exports.FolderInviteUuidDto = exports.GetFolderContentsDto = exports.FolderContentShowDto = exports.FolderContentByIdDto = exports.AddContentDto = exports.MoveFolderDto = exports.UpdateFolderDto = exports.CreateFolderDto = exports.FolderShowDto = exports.FolderByIdDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
class FolderByIdDto {
}
exports.FolderByIdDto = FolderByIdDto;
class FolderShowDto {
    constructor(folder) {
        if (folder) {
            this.id = folder.id;
            this.name = folder.name;
            this.category = folder.category;
            this.organizationId = folder.organizationId;
            this.facilityId = folder.facilityId;
            this.referableType = folder.referableType;
            this.referableId = folder.referableId;
            this.mainMediaId = folder.mainMediaId;
            this.createdAt = folder.createdAt;
            this.updatedAt = folder.updatedAt;
        }
    }
}
exports.FolderShowDto = FolderShowDto;
class CreateFolderDto {
}
exports.CreateFolderDto = CreateFolderDto;
class UpdateFolderDto {
}
exports.UpdateFolderDto = UpdateFolderDto;
class MoveFolderDto {
}
exports.MoveFolderDto = MoveFolderDto;
class AddContentDto {
}
exports.AddContentDto = AddContentDto;
class FolderContentByIdDto {
}
exports.FolderContentByIdDto = FolderContentByIdDto;
class FolderContentShowDto {
    constructor(folderContent) {
        if (folderContent) {
            this.id = folderContent.id;
            this.contentType = folderContent.contentType;
            this.contentId = folderContent.contentId;
        }
    }
}
exports.FolderContentShowDto = FolderContentShowDto;
class GetFolderContentsDto extends general_dto_1.PaginationQuery {
}
exports.GetFolderContentsDto = GetFolderContentsDto;
class FolderInviteUuidDto {
}
exports.FolderInviteUuidDto = FolderInviteUuidDto;
class FolderInviteShowDto {
    constructor(folderInvite) {
        if (folderInvite) {
            this.id = folderInvite.id;
            this.folderId = folderInvite.folderId;
            this.uuid = folderInvite.uuid;
            this.createdAt = folderInvite.createdAt;
            this.updatedAt = folderInvite.updatedAt;
        }
    }
}
exports.FolderInviteShowDto = FolderInviteShowDto;
class MoveFolderContentDto {
}
exports.MoveFolderContentDto = MoveFolderContentDto;
class GetFolderHierarchyDto {
}
exports.GetFolderHierarchyDto = GetFolderHierarchyDto;
class FolderHierarchyResponseDto {
}
exports.FolderHierarchyResponseDto = FolderHierarchyResponseDto;
/**
 * DTO to get a flat list of all the folders for a given referer (eg. ProgramSeason).
 *
 * Why isn't this paginated?
 * 	- Folders are stored in a hierarchy, there is no natural way to paginate them.
 * 	- Sub-folders may not share the same refererType/Id to query against.
 * 		EG: with a segmented ProgramSeason, the sub-folders will have the referer attributes of the
 * 		ProgramSeason representing the segment, the not parent.
 *
 */
class GetFoldersDto extends GetFolderHierarchyDto {
    constructor() {
        super(...arguments);
        this.sortColumn = 'name';
        this.sortOrder = 'asc';
    }
}
exports.GetFoldersDto = GetFoldersDto;
//# sourceMappingURL=folder.dto.js.map